import React from 'react';
import { connect } from 'react-redux';
import { fetchUniqueUserstData, uniqueUsersCountFilterSelected } from '../../../actions/analytics/isiAnywhere/uniqueUserCounts';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';
import { useRef } from 'react';
import { Bar, getElementsAtEvent } from 'react-chartjs-2';
import { withOktaAuth } from '@okta/okta-react';

Chart.register(ChartDataLabels);
class UniqueUsersCount extends React.Component {

    constructor(props) {
        super(props);

        this.chartRef = React.createRef();
    }

    getInitialGraphData = async () => {

        //check if users is authenticated then call Action to get API data
        if (this.props.authState.isAuthenticated) {
            let authObj = {};
            const userInfo = await this.props.oktaAuth.getUser();
            //console.log("USER INFO", userInfo);
            authObj.curUserInfo = userInfo;
            authObj.token = this.props.authState.accessToken;
            //Action to check if user has analytics access
            console.log("Getting Unique Users counts Data.");
            await this.props.fetchUniqueUserstData(authObj.token);

        }
    }

    componentDidMount() {
        if (Object.keys(this.props.user).length === 0) {
            this.getInitialGraphData();
        }
    }


    onClickBar = (event) => {
        console.log("Clicked the Unique Users Bar Graph");
    }

    onClickFilter = async (event) => {
        console.log("Unique User Filter Clicked: ", event.target.innerText);
        await this.props.uniqueUsersCountFilterSelected(event.target.innerText);

    }

    render() {
        //console.log("TEST ATTA!!!! ", this.props.analytics);
        let curFilter = this.props.uniqueUserFilter;
        let curCountsTest = [];
        let curLabelsTest = [];
        let curTotalCount = 0;
        let xAxisName = "Months";
        let secondTitleLine = "";

        if (curFilter === "Daily" && !this.props.isLoading) {

            //set x axis name
            xAxisName = "Days"

            secondTitleLine = `Total num of Days: ${this.props.analytics.DailyCounts.length}`;

            //find sum of all distinct users for this filter, initialize sum to 0 and add each uniqueUsers to the Sum
            curTotalCount = this.props.analytics.DailyCounts.reduce((sum, obj) => sum + obj.userCount, 0);

            //set cur counts array to data based on current filter
            curCountsTest = this.props.analytics.DailyCounts.map(curDay => curDay.userCount);
            //set labels bases on current filter
            curLabelsTest = this.props.analytics.DailyCounts.map(curDay => curDay.day);
            console.log("TEST Unique Users data!!! ", curCountsTest, curLabelsTest);
        }
        else if (curFilter === "Weekly" && !this.props.isLoading) {
            //set x axis name
            xAxisName = "Weeks"
            secondTitleLine = `Total num of Weeks: ${this.props.analytics.WeekCounts.length}`;

            //find sum of all distinct users for this filter, initialize sum to 0 and add each uniqueUsers to the Sum
            curTotalCount = this.props.analytics.WeekCounts.reduce((sum, obj) => sum + obj.userCount, 0);

            curCountsTest = this.props.analytics.WeekCounts.map(curWeek => curWeek.userCount);
            curLabelsTest = this.props.analytics.WeekCounts.map(curWeek => curWeek.day);
            console.log("TEST Unique Users data!!! ", curCountsTest, curLabelsTest);
        }
        else if (curFilter === "Monthly" && !this.props.isLoading) {
            //set x axis name
            xAxisName = "Months"
            secondTitleLine = `Total num of Months: ${this.props.analytics.MonthCounts.length}`;

            curTotalCount = this.props.analytics.MonthCounts.reduce((sum, obj) => sum + obj.userCount, 0);
            curCountsTest = this.props.analytics.MonthCounts.map(curMonth => curMonth.userCount);
            curLabelsTest = this.props.analytics.MonthCounts.map(curMonth => curMonth.day);
            console.log("TEST Unique Users data!!! ", curCountsTest, curLabelsTest);
        }
        // const counts = this.props.analytics.approvalTimes30days.map(item => item.count);
        // const labels = this.props.analytics.approvalTimes30days.map(item => item.label);
        const curCounts = ["1000", "855", "925", "1213"];
        const curLabels = ["January", "February", "March", "April"];
        //const chartRef = useRef();
        const data = {
            options: {
                legend: {
                    display: '',
                },
            },
            labels: curLabelsTest,
            datasets: [
                {
                    type: 'bar',
                    label: 'Unique Users',
                    data: curCountsTest,
                    backgroundColor: 'rgba(28,35,186)',
                    borderColor: 'rgba(28,35,186)',
                    borderWidth: 1
                },
            ]
        };
        const chartOptions = {
            scales: {
                y: {
                    title: {
                        display: true,
                        text: 'Unique User Count'
                    }
                },
                x: {
                    title: {
                        display: true,
                        text: xAxisName
                    }
                }
            },
            plugins: {
                title: {
                    display: false,
                    // text: `Total sum of users for current graph: ${curTotalCount}`,
                    text: [
                        `Total sum of users for current graph: ${curTotalCount}`,
                        `${secondTitleLine}`
                    ],
                    padding: {
                        top: 0, // Adjust this value to raise the title higher
                        bottom: 25
                    }
                },
                legend: {
                    display: false,
                },
                datalabels: {
                    display: true,
                    color: 'black',
                    anchor: 'end',
                    align: 'top',
                    padding: {
                        top: 1,
                        bottom: 3,
                    },
                    formatter: (value) => value,
                }
            }
        }

        return (
            <div className='card'>
                <div className='card-header'>
                    <div class="card-head-row">
                        <div class="card-title">Unique Users by Click Count</div>
                        <button class="btn btn-link" id="uniqueUserInfo" data-toggle="tooltip" href="#" data-placement="top" data-html="true" title="Daily: unique daily users<br>Weekly: unique weekly users<br>Monthly: unique monthly users">(i)</button>
                        <div class="card-tools">
                            <ul class="nav  nav-pills nav-secondary nav-pills-no-bd nav-sm" id="pills-tab" role="tablist">
                                {/* <li class="nav-item" style={{ alignContent: "center" }}>
                                    <a>Total Count: {curTotalCount}</a>
                                </li> */}
                                <li class="nav-item submenu" onClick={this.onClickFilter}>
                                    <a class="nav-link intuitive-pill" data-toggle="pill" id="pills-unique-daily" href="#pills-unique-daily" role="tab" aria-selected="false" >Daily</a>
                                </li>
                                <li class="nav-item submenu" onClick={this.onClickFilter}>
                                    <a class="nav-link  show" data-toggle="pill" id="pills-unique-weekly" href="#pills-unique-weekly" role="tab" aria-selected="true" >Weekly</a>
                                </li>
                                <li class="nav-item submenu" onClick={this.onClickFilter}>
                                    <a class="nav-link active" data-toggle="pill" id="pills-unique-montly" href="#pills-unique-montly" role="tab" aria-selected="false">Monthly</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <div className='chart-container'>
                        <div>
                            {
                                this.props.isLoading ? <div class="loader loader-primary"></div> :
                                    <Bar
                                        ref={this.chartRef}
                                        data={data}
                                        onClick={this.onClickBar}
                                        options={chartOptions}
                                    />
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    console.log("Unique User Graph State:", state);
    return { user: state.user, analytics: state.uniqueUserCounts, isLoading: state.uniqueUserCountsIsLoading, uniqueUserFilter: state.selectedUniqueUsersCountsFilter };
}

export default connect(mapStateToProps, { fetchUniqueUserstData, uniqueUsersCountFilterSelected })(withOktaAuth(UniqueUsersCount));
//export default UniqueUserCount